import { SharedStyles } from '@opencare/shared-styles';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { BREAKPOINTS } from 'common/styles/style-constants';
import { Radio } from 'opencare-crown';

export const ToggleSelectGroup = styled(Radio.Group).attrs({ buttonStyle: 'solid', tabIndex: 0 })`
  display: flex;
  align-self: stretch;
`;

type ToggleSelectOptionProps = {
  $isInvalid?: boolean;
};

export const ToggleSelectOption = styled(Radio.Button)<ToggleSelectOptionProps>`
  && {
    ${TYPOGRAPHY.CIRCULAR.bold}

    width: 50%;
    height: auto;

    font-size: 16px;
    line-height: 20px;
    color: ${BRAND_COLORS.darkStroke};
    text-align: center;

    padding: 13px 24px;

    ${({ $isInvalid }) => $isInvalid && css`
      border-color: ${BRAND_COLORS.darkRed};
    `}

    &:focus-within {
      outline: none !important;
    }

    &.ant-radio-button-wrapper {
      cursor: pointer;

      &:first-child {
        border-radius: 8px 0 0 8px;
        border-right-width: 0.5px;
      }

      &:last-child {
        border-radius: 0 8px 8px 0;
        border-left-width: 0.5px;
      }

      &:not(:first-child)::before {
        content: none;
      }

      &:not(.ant-radio-button-wrapper-disabled):hover {
        color: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};
      }
    }

    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
      background: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};
      border-color: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};
      box-shadow: none;

      color: ${SharedStyles.COLOR.SURFACE.DEFAULT.INVERSE};
      font-weight: 600;

      &:active {
        background: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};
        border-color: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};
        box-shadow: none;
        color: ${SharedStyles.COLOR.SURFACE.DEFAULT.INVERSE};
      }

      &:hover {
        background: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};
        border-color: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};
        box-shadow: none;
        color: ${SharedStyles.COLOR.SURFACE.DEFAULT.INVERSE};
      }
    }

    & > span {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    & > .ant-radio-button {
      height: auto;
    }

    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      padding: 8px 0;
    }
  }
`;
